import {useCallback} from 'react'

import {
  DockedPanel,
  type ManageBatchEntrySurface,
  type PanelOpenOptions,
  useDockedPanelActions,
} from '../contexts/DockedPanelContext'

/**
 * Opens the Manage batch panel from `entrySurface`.
 *
 * The entry surface is recorded in panel metadata rather than reported by the
 * caller, so `ManageBatchOpenTelemetry` can emit a single
 * `unified_batch_panel.open` when the panel actually becomes active. Callers
 * must not call `openPanel(DockedPanel.ManageBatchReviewComments)` directly —
 * doing so would report the open as `'unknown'`.
 */
export function useOpenManageBatchPanel(entrySurface: ManageBatchEntrySurface) {
  const {openPanel} = useDockedPanelActions()

  return useCallback(
    (options?: Omit<PanelOpenOptions, 'metadata'>) =>
      openPanel(DockedPanel.ManageBatchReviewComments, {
        ...options,
        metadata: {manageBatchEntrySurface: entrySurface},
      }),
    [entrySurface, openPanel],
  )
}
